<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="
            interview
                ? { key: 'applicant-tracker.manageInterviewNameInterview', params: { interviewName: interview.name } }
                : 'applicant-tracker.manageInterview'
        "
        subtitle="applicant-tracker.messages.interview.specifyWhoFromTheHiringTeam"
        [back]="true"
    ></app-header>
    <ui-card *ngIf="this.selectedApplicants.length; else empty">
        <div class="app-grid">
            <p class="columns-3">{{ 'applicant-tracker.interviews-table.name' | translate }}</p>
            <p id="dueDate-column" class="columns-4">{{ 'applicant-tracker.interviews-table.dueDate' | translate }}*</p>
            <p id="interviewers-column" class="columns-4">
                {{ 'applicant-tracker.interviews-table.interviewers' | translate }}*
            </p>
        </div>
        <mat-divider></mat-divider>
        <form [formGroup]="formGroup">
            <div role="list">
                <div role="listitem" *ngFor="let selectedApplicant of selectedApplicants; let i = index">
                    <div class="app-grid margin-top-2 margin-bottom-2 align-items-center">
                        <div class="columns-3" id="name-{{ i }}">{{ selectedApplicant.fullName }}</div>

                        <ng-container formGroupName="dueDateGroup">
                            <ui-date-picker
                                [labelVisible]="false"
                                [label]="
                                    selectedApplicant.fullName +
                                    ' ' +
                                    ('applicant-tracker.interviews-table.dueDate' | translate)
                                "
                                class="columns-4"
                                [formControlName]="selectedApplicant.id.toString()"
                                [minDate]="minDate"
                                [required]="true"
                                [hideRequiredMarker]="true"
                            ></ui-date-picker>
                        </ng-container>

                        <ng-container formGroupName="interviewersGroup">
                            <mat-form-field class="columns-4 no-labels no-helpers">
                                <mat-select
                                    aria-labelledby="name-{{ i }} interviewers-column"
                                    placeholder="{{ 'applicant-tracker.selectAllThatApply' | translate }}"
                                    [formControlName]="selectedApplicant.id"
                                    multiple
                                >
                                    <mat-option *ngFor="let interviewer of interviewers" [value]="interviewer.id">{{
                                        interviewer.fullName
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-container>
                    </div>

                    <mat-divider></mat-divider>
                </div>
            </div>
        </form>
    </ui-card>
    <div class="flex justify-end">
        <ui-button type="ghost" [routerLink]="['../']">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave(formGroup)">{{ 'assign' | translate }}</ui-button>
    </div>
</div>

<ng-template #empty>
    <ui-card>
        <app-empty-state
            src="/assets/illustrations/documents.png"
            label="{{ 'applicant-tracker.noApplicantsToAssign' | translate }}"
        ></app-empty-state>
    </ui-card>
</ng-template>
